/** La boucle de pilotage continue de Grafton : le dirigeant valide, Grafton exécute, on mesure, on corrige. */
const ETAPES = [
  { n: 1, t: "Objectif", d: "Chiffre d'affaires et horizon" },
  { n: 2, t: "Données fiables", d: "Validées par vous" },
  { n: 3, t: "Plan d'actions", d: "Étapes et jalons en %" },
  { n: 4, t: "Votre accord", d: "Vous autorisez chaque action" },
  { n: 5, t: "Exécution", d: "Grafton déploie avec vous" },
  { n: 6, t: "Mesure et revue", d: "Poursuivre, arrêter, ajuster" },
];

export default function BoucleDiagram({ active }: { active?: number }) {
  return (
    <div className="rounded-xl border border-border bg-card/60 p-4" data-testid="boucle-diagram">
      <div className="flex items-center justify-between flex-wrap gap-2 mb-3">
        <p className="text-sm font-semibold">La boucle de pilotage continue</p>
        <p className="text-xs text-muted-foreground">Chaque mois la revue relance la boucle : rien n'est déployé sans votre accord.</p>
      </div>
      <ol className="grid grid-cols-2 md:grid-cols-6 gap-2">
        {ETAPES.map((e) => (
          <li key={e.n} className={`relative rounded-lg border p-3 ${active === e.n ? "border-primary bg-primary/10" : "border-border/60"}`}>
            <span className="absolute -top-2 left-3 text-[10px] px-1.5 rounded-full bg-background border border-border text-muted-foreground">{e.n}</span>
            <p className="text-xs font-semibold mt-1">{e.t}</p>
            <p className="text-[11px] text-muted-foreground leading-snug">{e.d}</p>
          </li>
        ))}
      </ol>
      <div className="flex items-center gap-2 mt-3 text-xs text-primary">
        <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M3 12a9 9 0 0 1 15-6.7L21 8" /><path d="M21 3v5h-5" /><path d="M21 12a9 9 0 0 1-15 6.7L3 16" /><path d="M3 21v-5h5" /></svg>
        Le résultat de la revue (6) nourrit l'objectif et le plan (1 et 3) du mois suivant.
      </div>
    </div>
  );
}
